import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import {firstLetterText, messageReplace,urlify} from "../../lib/helper.js";
import TimeAgo from "react-timeago";
import ModalImage from "react-modal-image";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class LeftMessage extends Component {

    constructor(props) {
        super(props);

		this.convertDate=this.convertDate.bind(this);
    }
	
	convertDate(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = (a.getMonth() < 10 ? '0':'')+a.getMonth();
  var date = (a.getDate() < 10 ? '0':'')+a.getDate();
  var hour = (a.getHours() < 10 ? '0':'')+a.getHours();
  var min = (a.getMinutes() < 10 ? '0':'')+a.getMinutes();
  var sec = (a.getSeconds() < 10 ? '0':'')+a.getSeconds();
  var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min;
  return time;
    }

    componentWillUpdate(prevProps, prevState, snapshot) {

    }
    render() {
        const { t } = this.props;

        if(this.props.message.message_type==="text"){

             var $user_data_name="";
            if(typeof this.props.beforeMessage==="undefined" || typeof this.props.beforeMessage.sender_id==="undefined" || (this.props.beforeMessage.sender_id != this.props.message.sender_id)){
                if(typeof this.props.message.user_data_name !== "undefined"){
                    $user_data_name=this.props.message.user_data_name;
                }

            }

            return (
                <div className="chats">
                    <div className="chat-content">
                        {$user_data_name != "" &&
                        <div className="chat-profile-name">
                            <h6>
                                {this.props.message.user_data_name}

                            </h6>
                        </div>
                        }



                    <div className="message-content" style={{"text-align":"-webkit-left"}}>

{typeof this.props.message.file!=="undefined" && this.props.message.file != "" && this.props.message.file != "undefined" && this.props.message.file.substring(this.props.message.file.lastIndexOf(".")+1) !== "pdf" &&
		
		<>
		{this.props.message.file.includes('https://') &&

		<ModalImage
        small={this.props.message.file}
        large={this.props.message.file}
        className="popupImageRight"
		/>
	  
		}
		
		{this.props.message.file.includes('https://') == false &&

		<ModalImage
        small={"https://service.itemci.com/Public/images/chat/"+this.props.message.file}
        large={"https://service.itemci.com/Public/images/chat/"+this.props.message.file}
        className="popupImageLeft"
		/>
	  
		}
		</>
}

{typeof this.props.message.file!=="undefined" && this.props.message.file != "" && this.props.message.file != "undefined" && this.props.message.file.substring(this.props.message.file.lastIndexOf(".")+1) == "pdf" &&
	
<>
	{this.props.message.file.includes('https://') &&

		<a href={this.props.message.file} target="_blank" download>
					<img src="https://service.itemci.com/Public/images/classic/pdf.jpeg" class="popupImageRight" />
				</a>
	  
		}
		
		{this.props.message.file.includes('https://') == false &&

		<a href={"https://service.itemci.com/Public/images/chat/"+this.props.message.file} target="_blank" download>
					<img src="https://service.itemci.com/Public/images/classic/pdf.jpeg" class="popupImageLeft" />
				</a>
	  
		}
		
		</>
}

	  
					<span style={{"text-align": "justify","width": "100%","display": "block"}} dangerouslySetInnerHTML={{__html: urlify(messageReplace(this.props.message.message.replace(/\n/g,"<br />")))}}></span>

                    </div>
					
					
					{ ((Date.now() / 1000) - this.props.message.message_time) >= 3600 &&
					
					<div className="chat-profile-name">
                            <h6 style={{"font-size":"11px", "margin-bottom":"0"}}>
                                {this.convertDate(this.props.message.message_time)}
                            </h6>
                    </div>
					
					}
					
					{ ((Date.now() / 1000) - this.props.message.message_time) < 3600 && (typeof this.props.nextMessage === "undefined" || this.props.nextMessage.sender_id != this.props.message.sender_id) &&

                                <span className="messageTimeSpan"><TimeAgo now={function now(){ return (Date.now() + (60*60*3*1000)) }}
                                    date={new Date(((this.props.message.message_time * 1000) + (60*60*3*1000)))}/></span>

					
					}
					
					
                    </div>
                </div>
            )

        }

        if(this.props.message.message_type==="prechatform"){

            return (
                <div className="chats">
                    <div className="chat-content">
                        <div className="prechat-form-message-content">
                            <div className="prechat-form-message-title">
                                Pre-chat form
                            </div>

                            <div className="prechat-form-message-body">
                                {Object.keys(this.props.message.message).length > 0 &&
                                    <>
                                    {Object.keys(this.props.message.message).map((m)=>{

                                        return <React.Fragment>
                                            <div>
                                                <span className="prechat-form-message-body-title">{firstLetterText(this.props.message.message[m]['name'])}</span>
                                            </div>
                                            <div>{this.props.message.message[m]['val']}</div>
                                        </React.Fragment>

                                    })}

                                    </>
                                }
                            </div>
                        </div>
						{ ((Date.now() / 1000) - this.props.message.message_time) >= 3600 &&
						<div className="chat-profile-name">
                            <h6 style={{"font-size":"11px", "margin-bottom":"0"}}>
                                {this.convertDate(this.props.message.message_time)}
                            </h6>
						</div>
						}
                    </div>
                </div>

            );

        }



    }
}

export default withTranslation()(LeftMessage);




